import { render, staticRenderFns } from "./level2.vue?vue&type=template&id=052d2904&scoped=true&"
import script from "./level2.vue?vue&type=script&lang=js&"
export * from "./level2.vue?vue&type=script&lang=js&"
import style0 from "./level2.vue?vue&type=style&index=0&id=052d2904&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052d2904",
  null
  
)

export default component.exports